import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import About from './views/About.vue'
import Contact from './views/Contact.vue'
import Services from './views/Services.vue'
import Projects from './views/Projects.vue'
import Status from './views/Status'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
			meta: {
				title: 'Codestage | The software development company trusted by big companies'
			}
		},
		{
			path: '/about',
			name: 'about',
			component: About,
			meta: {
				title: 'Codestage | About us'
			}
		},
		{
			path: '/services',
			name: 'services',
			component: Services,
			meta: {
				title: 'Codestage | Our services'
			}
		},
		{
			path: '/projects',
			name: 'projects',
			component: Projects,
			meta: {
				title: 'Codestage | Our projects'
			}
		},
		{
			path: '/status',
			name: 'status',
			component: Status,
			meta: {
				title: 'Codestage | System status'
			}
		},
		{
			path: '/contact',
			name: 'contact',
			component: Contact,
			meta: {
				title: 'Codestage | Contact us'
			}
		}
	]
})
